<div class="w-full mx-auto p-5 space-y-5">

  <!-- ============================================================ -->
  <!-- Header                                                       -->
  <!-- ============================================================ -->
  <div class="flex flex-wrap justify-between items-end gap-4">
    <div>
      <div class="flex items-center gap-2 text-xs font-medium text-slate-500 uppercase tracking-wider">
        <span>Ingresos</span>
        <span class="text-slate-300">/</span>
        <span class="text-slate-700">Individuales</span>
      </div>
      <h1 class="text-2xl font-semibold text-slate-900 mt-1">Comprobantes Individuales</h1>
      <p class="text-sm text-slate-500 mt-1">
        {{ individualReceipts }} comprobantes · Registro y seguimiento de ingresos individuales
      </p>
    </div>
    <a routerLink="/income-receipts/new"
      class="bg-slate-900 text-white px-4 py-2 rounded-lg hover:bg-slate-800 transition flex items-center gap-2 text-sm font-medium shadow-sm">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
      </svg>
      Nuevo Comprobante
    </a>
  </div>

  <!-- ============================================================ -->
  <!-- KPIs                                                         -->
  <!-- ============================================================ -->
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">

    <div class="kpi-card kpi-sky">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </span>
        Total Bruto
      </div>
      <div class="kpi-value">{{ totalGross | currency }}</div>
      <div class="kpi-hint">Suma de comprobantes individuales</div>
    </div>

    <div class="kpi-card kpi-rose">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </span>
        Descuentos
      </div>
      <div class="kpi-value">{{ totalDiscounts | currency }}</div>
      <div class="kpi-hint">Descuentos y comisiones aplicados</div>
    </div>

    <div class="kpi-card kpi-emerald">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
          </svg>
        </span>
        Neto Recibido
      </div>
      <div class="kpi-value">{{ totalNet | currency }}</div>
      <div class="kpi-hint">Total efectivamente recibido</div>
    </div>

    <div class="kpi-card kpi-violet">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
          </svg>
        </span>
        Comprobantes
      </div>
      <div class="kpi-value">{{ individualReceipts }}</div>
      <div class="kpi-hint">Total emitidos (vista actual)</div>
    </div>

  </div>

  <!-- ============================================================ -->
  <!-- Toolbar de filtros (una sola fila, alturas consistentes)     -->
  <!-- ============================================================ -->
  <div class="filters-toolbar">
    <div class="grid grid-cols-12 gap-3">

      <!-- Buscar (col-span amplio) -->
      <div class="col-span-12 md:col-span-4">
        <div class="relative">
          <svg class="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input type="text" [(ngModel)]="searchTerm" (input)="onFilterChange()"
            placeholder="Buscar por participante, documento o referencia..."
            class="w-full pl-9 pr-3 h-[38px] border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-400">
        </div>
      </div>

      <!-- ID -->
      <div class="col-span-6 md:col-span-2">
        <input type="number" [(ngModel)]="filterId" (ngModelChange)="onFilterChange()" placeholder="ID #"
          class="w-full px-3 h-[38px] border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-400 tabular-nums">
      </div>

      <!-- Método de pago -->
      <div class="col-span-6 md:col-span-2">
        <p-dropdown [options]="paymentMethods" [(ngModel)]="selectedPaymentMethod" (onChange)="onFilterChange()"
          styleClass="w-full" placeholder="Método" optionLabel="name" optionValue="id" [showClear]="true"
          appendTo="body" panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <!-- Tipo de pago -->
      <div class="col-span-6 md:col-span-2">
        <p-dropdown [options]="[
            {label: 'Tipo de pago', value: null},
            {label: 'Manual', value: true},
            {label: 'Automático', value: false}
          ]" [(ngModel)]="selectedPaymentType" (onChange)="onFilterChange()" styleClass="w-full"
          placeholder="Tipo" optionLabel="label" optionValue="value" [showClear]="true" appendTo="body"
          panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <!-- Estado anulación + ordenamiento (juntos a la derecha) -->
      <div class="col-span-6 md:col-span-2 flex gap-2">
        <p-dropdown [options]="[
            {label: 'Solo Activos', value: 'active'},
            {label: 'Solo Anulados', value: 'cancelled'},
            {label: 'Todos', value: 'all'}
          ]" [(ngModel)]="selectedCancellationFilter" (onChange)="onCancellationFilterChange()"
          styleClass="flex-1" placeholder="Estado" optionLabel="label" optionValue="value" appendTo="body"
          panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>

        <button (click)="toggleSortOrder()"
          class="flex-shrink-0 h-[38px] px-3 border border-slate-200 rounded-lg bg-white hover:bg-slate-50 flex items-center gap-1 text-sm text-slate-700 transition-colors"
          [title]="'Ordenar por ID ' + (sortOrder === 'desc' ? 'descendente' : 'ascendente')">
          <svg class="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path *ngIf="sortOrder === 'desc'" stroke-linecap="round" stroke-linejoin="round"
              d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" />
            <path *ngIf="sortOrder === 'asc'" stroke-linecap="round" stroke-linejoin="round"
              d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
          </svg>
          <span class="tabular-nums">ID</span>
        </button>
      </div>

      <!-- Fila 2: controles de fecha ocupando el ancho completo -->
      <div class="col-span-12 md:col-span-4">
        <p-dropdown [(ngModel)]="dateType" [options]="dateTypeOptions" (onChange)="onFilterChange()" styleClass="w-full"
          placeholder="Tipo de fecha" optionLabel="label" optionValue="value" appendTo="body"
          panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <div class="col-span-6 md:col-span-4">
        <p-calendar [(ngModel)]="startDate" (onSelect)="onFilterChange()" (onClearClick)="onFilterChange()"
          [showIcon]="true" placeholder="Desde" dateFormat="dd/mm/yy" [showClear]="true" styleClass="w-full"
          appendTo="body" panelStyleClass="filter-datepicker-panel">
        </p-calendar>
      </div>

      <div class="col-span-6 md:col-span-4">
        <p-calendar [(ngModel)]="endDate" (onSelect)="onFilterChange()" (onClearClick)="onFilterChange()"
          [showIcon]="true" placeholder="Hasta" dateFormat="dd/mm/yy" [showClear]="true" styleClass="w-full"
          appendTo="body" panelStyleClass="filter-datepicker-panel">
        </p-calendar>
      </div>

    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Listado                                                      -->
  <!-- ============================================================ -->
  <div class="space-y-3">

    <!-- Empty state -->
    <div *ngIf="paginatedReceipts.length === 0"
      class="bg-white border border-dashed border-slate-300 rounded-xl p-10 text-center">
      <div class="mx-auto w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-3">
        <svg class="w-6 h-6 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M9 17v-2a4 4 0 014-4h0a4 4 0 014 4v2M3 7l9-4 9 4-9 4-9-4z" />
        </svg>
      </div>
      <p class="text-sm font-medium text-slate-700">No se encontraron comprobantes</p>
      <p class="text-xs text-slate-500 mt-1">Ajusta los filtros o crea un nuevo comprobante.</p>
    </div>

    <div *ngFor="let receipt of paginatedReceipts" class="receipt-row"
      [class.is-cancelled]="receipt.isCancelled"
      [class.stripe-rose]="receipt.isCancelled"
      [class.stripe-violet]="!receipt.isCancelled && isPendingApproval(receipt)"
      [class.stripe-emerald]="!receipt.isCancelled && !isPendingApproval(receipt) && receipt.isBankReconciled"
      [class.stripe-amber]="!receipt.isCancelled && !isPendingApproval(receipt) && !receipt.isBankReconciled">

      <!-- Barra lateral de estado -->
      <div class="status-stripe"></div>

      <!-- Contenido -->
      <div class="p-4 space-y-3">

        <!-- ---------- Fila principal: identidad + monto ---------- -->
        <div class="flex items-start justify-between gap-4">

          <!-- Identidad (izquierda) -->
          <div class="min-w-0 flex-1">
            <div class="flex items-center flex-wrap gap-2">
              <a [routerLink]="['/income-receipts/view', receipt.id]" target="_blank"
                class="inline-flex items-center gap-1.5 text-base font-semibold text-slate-900 hover:text-blue-700 transition-colors group">
                <span class="tabular-nums">#{{ receipt.id }}</span>
                <svg class="w-3.5 h-3.5 text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity"
                  fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>

              <span *ngIf="hasVersionInfo(receipt)"
                class="text-[10px] font-semibold text-purple-700 bg-purple-50 border border-purple-100 rounded px-1.5 py-0.5">
                v{{ receipt.version }}
              </span>

              <!-- Píldoras de estado, en línea, sin duplicar info -->
              <span *ngIf="receipt.isCancelled" class="pill pill-rose">
                <i class="fas fa-ban"></i> Anulado
              </span>

              <span *ngIf="getApprovalStatusInfo(receipt) as approvalInfo" class="pill pill-violet">
                <i class="fas" [ngClass]="approvalInfo.icon"></i> {{ approvalInfo.label }}
              </span>

              <span class="pill"
                [ngClass]="receipt.isManualPayment ? 'pill-amber' : 'pill-emerald'">
                {{ receipt.isManualPayment ? 'Manual' : 'Automático' }}
              </span>

              <span class="pill"
                [ngClass]="receipt.isBankReconciled ? 'pill-sky' : 'pill-neutral'"
                [title]="receipt.isBankReconciled
                  ? 'Conciliado el ' + (receipt.bankReconciledAt | date:'short') + ' por ' + receipt.bankReconciledBy
                  : 'Pendiente de conciliación bancaria'">
                <i class="fas" [ngClass]="receipt.isBankReconciled ? 'fa-check-circle' : 'fa-clock'"></i>
                {{ receipt.isBankReconciled ? 'Conciliado' : 'Sin conciliar' }}
              </span>
            </div>

            <!-- Participante + proyecto -->
            <div class="mt-2 flex flex-wrap items-baseline gap-x-3 gap-y-1">
              <span class="text-sm font-medium text-slate-800 flex items-center gap-1.5">
                <svg class="w-3.5 h-3.5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                {{ getPayerDisplayText(receipt) }}
              </span>
              <span class="text-xs text-slate-400 tabular-nums">{{ getParticipantDocument(receipt) }}</span>
            </div>
            <p class="mt-0.5 text-xs text-slate-500 truncate">
              {{ receipt.project.projectId }} · {{ receipt.project.name }}
            </p>
          </div>

          <!-- Monto (derecha) — ancla visual -->
          <div class="flex-shrink-0 text-right">
            <p class="text-[11px] font-medium text-slate-400 uppercase tracking-wide">Neto</p>
            <p class="text-xl font-semibold text-slate-900 tabular-nums leading-tight">
              {{ formatCurrencyValue(receipt.netAmount, receipt) }}
            </p>
            <p *ngIf="hasExchangeRate(receipt)" class="text-[11px] text-purple-600 tabular-nums mt-0.5">
              ≈ {{ getCOPEquivalent(receipt.netAmount, receipt) }}
            </p>
          </div>
        </div>

        <!-- ---------- Grid de metadatos ---------- -->
        <div class="grid grid-cols-2 md:grid-cols-6 gap-x-4 gap-y-3 pt-3 border-t border-slate-100">

          <div class="data-cell">
            <span class="data-label">{{ receipt.paymentPlan ? 'Cuota' : 'Tipo' }}</span>
            <span class="data-value tabular-nums">
              <ng-container *ngIf="receipt.paymentPlan; else noPlan">
                #{{ receipt.paymentPlan.installmentNumber }}
              </ng-container>
              <ng-template #noPlan>
                <span class="text-purple-700">Plan Corporativo</span>
              </ng-template>
            </span>
          </div>

          <div class="data-cell">
            <span class="data-label">Método</span>
            <span class="data-value">{{ receipt.paymentMethod.name }}</span>
          </div>

          <div class="data-cell">
            <span class="data-label">Creación</span>
            <span class="data-value tabular-nums">{{ receipt.createdAt | date:'dd/MM/yy' }}</span>
          </div>

          <div class="data-cell">
            <span class="data-label">Pago</span>
            <span class="data-value tabular-nums">{{ receipt.transactionDate | date:'dd/MM/yy' }}</span>
          </div>

          <div class="data-cell">
            <span class="data-label">Bruto</span>
            <span class="data-value text-blue-700 tabular-nums">
              {{ formatCurrencyValue(receipt.grossAmount, receipt) }}
            </span>
            <span *ngIf="hasExchangeRate(receipt)" class="data-sub tabular-nums">
              ≈ {{ getCOPEquivalent(receipt.grossAmount, receipt) }}
            </span>
          </div>

          <div class="data-cell">
            <span class="data-label">Descuentos</span>
            <span class="data-value tabular-nums" [ngClass]="receipt.totalFees > 0 ? 'text-rose-700' : 'text-slate-500'">
              {{ formatCurrencyValue(receipt.totalFees, receipt) }}
            </span>
            <span *ngIf="hasExchangeRate(receipt) && receipt.totalFees > 0" class="data-sub tabular-nums">
              ≈ {{ getCOPEquivalent(receipt.totalFees, receipt) }}
            </span>
          </div>
        </div>

        <!-- ---------- Tasa de cambio (solo si aplica) ---------- -->
        <div *ngIf="hasExchangeRate(receipt)"
          class="flex items-center gap-2 text-xs text-purple-700 bg-purple-50/60 border border-purple-100 rounded-md px-3 py-2">
          <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 8c-1.657 0-3 .672-3 1.5S10.343 11 12 11s3-.672 3-1.5S13.657 8 12 8zm0 8c-1.657 0-3 .672-3 1.5S10.343 19 12 19s3-.672 3-1.5S13.657 16 12 16zm0-4c-1.657 0-3 .672-3 1.5S10.343 15 12 15s3-.672 3-1.5S13.657 12 12 12z" />
          </svg>
          <span>
            <strong class="font-semibold">Tasa:</strong>
            <span class="tabular-nums">{{ receipt.exchangeRate | number:'1.2-4' }}</span>
            ({{ receipt.currencyCode }} → COP)
            <span *ngIf="receipt.exchangeRateEffectiveDate" class="text-purple-500">
              · Vigente {{ receipt.exchangeRateEffectiveDate | date:'short' }}
            </span>
          </span>
        </div>

        <!-- ---------- Bloque de anulación ---------- -->
        <div *ngIf="receipt.isCancelled"
          class="bg-rose-50/60 border border-rose-200 rounded-md p-3 text-sm flex items-start gap-2">
          <svg class="w-4 h-4 text-rose-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor"
            viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
          <div class="flex-1 min-w-0">
            <p class="text-rose-800">
              <strong class="font-semibold">Motivo:</strong> {{ receipt.cancellationReason }}
            </p>
            <div class="flex flex-wrap justify-between gap-x-4 text-xs text-rose-600 mt-1">
              <span><strong>Por:</strong> {{ receipt.cancelledBy }}</span>
              <span><strong>Fecha:</strong> {{ receipt.cancelledAt | date:'medium' }}</span>
            </div>
          </div>
        </div>

        <!-- ---------- Justificación de edición pendiente ---------- -->
        <div *ngIf="receipt.editJustification && isPendingApproval(receipt)"
          class="text-xs text-slate-600 bg-slate-50 border border-slate-200 rounded-md px-3 py-2">
          <strong class="text-slate-700">Justificación:</strong> {{ receipt.editJustification }}
        </div>

        <!-- ---------- Auditoría ---------- -->
        <app-audit-info [auditData]="{
            createdBy: receipt.createdBy,
            createdAt: receipt.createdAt,
            updatedBy: receipt.updatedBy,
            updatedAt: receipt.updatedAt,
            deletedBy: receipt.deletedBy,
            deletedAt: receipt.deletedAt,
            isDeleted: receipt.isDeleted
          }" layout="compact" size="sm">
        </app-audit-info>

        <!-- ---------- Acciones ---------- -->
        <div class="flex flex-wrap items-center justify-end gap-1 pt-2 border-t border-slate-100">

          <!-- Acciones secundarias (izquierda implícita) -->
          <a *ngIf="receipt.paymentPlan?.enrollmentId"
            [routerLink]="['/dashboard/enrollments/view-v2/', receipt.paymentPlan.enrollmentId]" target="_blank"
            class="row-action" title="Ver inscripción en nueva pestaña">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <span>Ver Inscripción</span>
          </a>

          <button (click)="downloadPdf(receipt)" [disabled]="isDownloadingPdf[receipt.id]"
            class="row-action" title="Descargar PDF">
            <svg *ngIf="!isDownloadingPdf[receipt.id]" fill="none" viewBox="0 0 24 24"
              stroke-width="1.8" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
            </svg>
            <svg *ngIf="isDownloadingPdf[receipt.id]" class="animate-spin" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            <span>{{ isDownloadingPdf[receipt.id] ? 'Descargando…' : 'PDF' }}</span>
          </button>

          <a [routerLink]="['/income-receipts/view', receipt.id]" class="row-action row-action--primary"
            title="Ver detalles">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
            </svg>
            <span>Detalles</span>
          </a>

          <!-- Aprobar / Rechazar (solo si pendiente) -->
          <ng-container *ngIf="isPendingApproval(receipt)">
            <span class="action-divider"></span>
            <button (click)="showApprovalModal(receipt, 'Approve')" class="row-action row-action--success"
              title="Aprobar edición">
              <i class="fas fa-check-circle"></i>
              <span>Aprobar</span>
            </button>
            <button (click)="showApprovalModal(receipt, 'Reject')" class="row-action row-action--warning"
              title="Rechazar edición">
              <i class="fas fa-times-circle"></i>
              <span>Rechazar</span>
            </button>
          </ng-container>

          <!-- Anular (destructiva, siempre separada al final) -->
          <ng-container *ngIf="!receipt.isCancelled">
            <span class="action-divider"></span>
            <button [disabled]="receipt.isBankReconciled"
              [title]="receipt.isBankReconciled
                ? 'No se puede anular: comprobante conciliado bancariamente el '
                  + (receipt.bankReconciledAt | date:'medium') + ' por ' + receipt.bankReconciledBy
                : 'Anular comprobante'"
              (click)="!receipt.isBankReconciled && showCancelModal(receipt)"
              class="row-action row-action--danger">
              <i class="fas fa-ban"></i>
              <span>Anular</span>
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Paginador                                                    -->
  <!-- ============================================================ -->
  <div class="bg-white rounded-xl border border-slate-200">
    <p-paginator [rows]="pageSize" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 50, 100]"
      (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first}–{last} de {totalRecords}">
    </p-paginator>
  </div>

</div>

<!-- ============================================================ -->
<!-- Modal: Anulación                                             -->
<!-- ============================================================ -->
<div *ngIf="showConfirmationModal" class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true"
  [attr.aria-labelledby]="'cancel-modal-title'">

  <div class="fixed inset-0 bg-slate-900/50 backdrop-blur-sm transition-opacity duration-300"
    (click)="onCancelCancellation()">
  </div>

  <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
    <div
      class="relative transform overflow-hidden rounded-xl bg-white text-left shadow-2xl transition-all duration-300 ease-out sm:my-8 sm:w-full sm:max-w-lg">

      <div class="bg-white px-5 pb-4 pt-5 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">
          <div
            class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-rose-100 sm:mx-0 sm:h-10 sm:w-10">
            <i class="fas fa-ban text-rose-600 text-xl"></i>
          </div>

          <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
            <h3 class="text-base font-semibold leading-6 text-slate-900" id="cancel-modal-title">
              {{ confirmationConfig.title }}
            </h3>

            <div class="mt-2">
              <p class="text-sm text-slate-500 leading-relaxed">
                {{ confirmationConfig.message }}
              </p>
            </div>

            <div *ngIf="selectedReceiptForCancellation"
              class="mt-3 bg-slate-50 border border-slate-200 rounded-md p-3 text-sm text-slate-700 space-y-1">
              <p><span class="font-medium text-slate-500">Comprobante:</span> <span class="tabular-nums">#{{ selectedReceiptForCancellation.id }}</span></p>
              <p><span class="font-medium text-slate-500">Monto:</span> <span class="tabular-nums">{{ selectedReceiptForCancellation.grossAmount | currency }}</span></p>
              <p><span class="font-medium text-slate-500">Fecha:</span> <span class="tabular-nums">{{ selectedReceiptForCancellation.transactionDate | date:'mediumDate' }}</span></p>
            </div>

            <div class="mt-4">
              <label class="block text-sm font-medium text-slate-700 mb-2">
                Motivo de anulación <span class="text-rose-600">*</span>
              </label>
              <textarea [(ngModel)]="cancellationReason"
                class="w-full px-3 py-2 border border-slate-200 rounded-md focus:ring-2 focus:ring-rose-500 focus:border-rose-500 text-sm"
                rows="3" placeholder="Especifique el motivo de la anulación..." maxlength="1000" required>
              </textarea>
              <div class="mt-1 text-xs text-slate-500 text-right tabular-nums">
                {{ cancellationReason.length || 0 }}/1000
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-slate-50 px-5 py-3 sm:flex sm:flex-row-reverse sm:px-6 border-t border-slate-200">
        <button type="button"
          class="w-full inline-flex justify-center rounded-md bg-rose-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-rose-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500 sm:ml-3 sm:w-auto transition-colors duration-200"
          (click)="onConfirmCancellation()">
          {{ confirmationConfig.confirmText }}
        </button>
        <button type="button"
          class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-slate-700 shadow-sm ring-1 ring-inset ring-slate-300 hover:bg-slate-50 sm:mt-0 sm:w-auto transition-colors duration-200"
          (click)="onCancelCancellation()">
          {{ confirmationConfig.cancelText }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ============================================================ -->
<!-- Modal: Aprobación / Rechazo                                  -->
<!-- ============================================================ -->
<div *ngIf="showApprovalConfirmationModal" class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true"
  [attr.aria-labelledby]="'approval-modal-title'">

  <div class="fixed inset-0 bg-slate-900/50 backdrop-blur-sm transition-opacity duration-300"
    (click)="onCancelApproval()"></div>

  <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
    <div
      class="relative transform overflow-hidden rounded-xl bg-white text-left shadow-2xl transition-all duration-300 ease-out sm:my-8 sm:w-full sm:max-w-lg">

      <div class="bg-white px-5 pb-4 pt-5 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">

          <div
            class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10"
            [ngClass]="{
              'bg-emerald-100': approvalAction === 'Approve',
              'bg-amber-100': approvalAction === 'Reject'
            }">
            <i class="fas text-xl" [ngClass]="{
              'fa-check-circle text-emerald-600': approvalAction === 'Approve',
              'fa-times-circle text-amber-600': approvalAction === 'Reject'
            }"></i>
          </div>

          <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
            <h3 class="text-base font-semibold leading-6 text-slate-900" id="approval-modal-title">
              {{ approvalAction === 'Approve' ? 'Aprobar Edición' : 'Rechazar Edición' }}
            </h3>

            <div class="mt-2">
              <p class="text-sm text-slate-500 leading-relaxed">
                {{ approvalAction === 'Approve'
                ? '¿Está seguro de aprobar los cambios realizados a este comprobante? Los cambios serán aplicados permanentemente.'
                : '¿Está seguro de rechazar los cambios? El comprobante volverá a su estado anterior.' }}
              </p>
            </div>

            <div *ngIf="selectedReceiptForApproval"
              class="mt-3 bg-slate-50 border border-slate-200 rounded-md p-3 text-sm text-slate-700 space-y-1">
              <p><span class="font-medium text-slate-500">Comprobante:</span> <span class="tabular-nums">#{{ selectedReceiptForApproval.id }}</span></p>
              <p><span class="font-medium text-slate-500">Monto:</span> <span class="tabular-nums">{{ selectedReceiptForApproval.grossAmount | currency }}</span></p>
              <p *ngIf="selectedReceiptForApproval.editJustification">
                <span class="font-medium text-slate-500">Justificación:</span> {{ selectedReceiptForApproval.editJustification }}
              </p>
            </div>

            <div class="mt-4">
              <label class="block text-sm font-medium text-slate-700 mb-2">
                Notas {{ approvalAction === 'Reject' ? '*' : '(opcional)' }}
              </label>
              <textarea [(ngModel)]="approvalNotes"
                class="w-full px-3 py-2 border border-slate-200 rounded-md focus:ring-2 text-sm"
                [ngClass]="{
                  'focus:ring-emerald-500 focus:border-emerald-500': approvalAction === 'Approve',
                  'focus:ring-amber-500 focus:border-amber-500': approvalAction === 'Reject'
                }" rows="3"
                [placeholder]="approvalAction === 'Approve' ? 'Agregue notas opcionales...' : 'Indique el motivo del rechazo...'"
                maxlength="500">
              </textarea>
              <div class="mt-1 text-xs text-slate-500 text-right tabular-nums">
                {{ approvalNotes.length || 0 }}/500
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-slate-50 px-5 py-3 sm:flex sm:flex-row-reverse sm:px-6 border-t border-slate-200">
        <button type="button"
          [disabled]="isProcessingApproval || (approvalAction === 'Reject' && !approvalNotes.trim())"
          class="w-full inline-flex items-center justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm sm:ml-3 sm:w-auto transition-colors duration-200"
          [ngClass]="{
            'bg-emerald-600 hover:bg-emerald-700 focus:ring-emerald-500': approvalAction === 'Approve',
            'bg-amber-600 hover:bg-amber-700 focus:ring-amber-500': approvalAction === 'Reject',
            'opacity-50 cursor-not-allowed': isProcessingApproval || (approvalAction === 'Reject' && !approvalNotes.trim())
          }" (click)="onConfirmApproval()">
          <svg *ngIf="isProcessingApproval" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
            </path>
          </svg>
          {{ isProcessingApproval ? 'Procesando…' : (approvalAction === 'Approve' ? 'Confirmar Aprobación' : 'Confirmar Rechazo') }}
        </button>

        <button type="button" [disabled]="isProcessingApproval"
          class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-slate-700 shadow-sm ring-1 ring-inset ring-slate-300 hover:bg-slate-50 sm:mt-0 sm:w-auto transition-colors duration-200"
          (click)="onCancelApproval()">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
